import { Component, OnInit, Input } from '@angular/core';
import { ClinicalMessageService } from 'src/app/core/service/clinical-message.service';

@Component({
  selector: 'app-clinical-message-detail',
  templateUrl: './clinical-message-detail.component.html',
  styleUrls: ['./clinical-message-detail.component.scss']
})
export class ClinicalMessageDetailComponent implements OnInit
{
  @Input() public clinicalMessageId: number;

  public clinicalMessageContent: any;

  constructor(private clinicalMessageService: ClinicalMessageService)
  {
  }

  public ngOnInit(): void
  {
    this.clinicalMessageService.getClinicalMessageContent(this.clinicalMessageId).subscribe({
      next: (data) =>
      {
        this.clinicalMessageContent = JSON.parse(data);
      }
    });
  }
}
